import myAxiosApp from './myAxiosApp';
// import myAxiosTest from './myAxiosTest';
// import { areSpecsRunning } from '../components/ScrollReader/helpers';

// export default areSpecsRunning() ? myAxiosTest : myAxiosApp;
export default myAxiosApp;
